<template>
  <splitpanes class="default-theme splitPanesMain"
              :push-other-panes="false">
    <pane size='50'
          min-size="20"
          max-size="60">
      <div class="splitPanesMain_leftMenu">
        <a-card :bordered="false">
          <AuthTree :idKey="rbac.$state.models.role[0].id"
                    sourceUrlKey="roles"
                    targetUrlKey="roles"
                    resultKey="menus">
          </AuthTree>
        </a-card>
      </div>
    </pane>
    <pane size='50'
          min-size="20"
          max-size="60">
      <div class="splitPanesMain_rightMenu">
        <a-card :bordered="false">
          <AuthTree :idKey="rbac.$state.models.role[0].id"
                    sourceUrlKey="roles"
                    targetUrlKey="roles"
                    resultKey="operations"></AuthTree>
        </a-card>
      </div>
    </pane>
  </splitpanes>
</template>

<script setup lang="ts">
import { Pane, Splitpanes } from 'splitpanes'
import { useRbacStore } from '../../DefaultRbacPagePlugin'
import AuthTree from '../menu/AuthTree.vue'

const rbac = useRbacStore()

</script>

<style lang="less" scoped>
:deep(.ant-tree-list) {
  padding-bottom: 50px;
}

.splitPanesMain {
  height: 82vh;

  &_leftMenu {
    height: 99%;
    margin: 3px;
    background-color: white;
    box-shadow: 3px 0 2px #e8e3e3;
    overflow: auto
  }

  &_rightMenu {
    height: 99%;
    margin: 3px;
    background-color: white;
    box-shadow: 3px 0 2px #e8e3e3;
    overflow: auto
  }
}

:deep(.splitpanes__splitter) {
  background-color: #fbf3f314 !important;
}

:deep(.ant-empty) {
  height: 65vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
